import {AuthApiService} from "base/service";
import ServiceUtil, {ServiceRequestFormat} from "base/utilities/ServiceUtil";

const url = "/api/infrastructures/pending_changes";

const PendingChangesService = {
    getList(filter = {}, page = 1, sort = "", order = "", format = ServiceRequestFormat.JSON) {
        const params = new URLSearchParams({
            ...filter,
            ordering: sort ? (order === "desc" ? `-${sort}` : sort) : "",
        });
        if (format && format !== ServiceRequestFormat.JSON) {
            params.append("format", format);
        }
        if (page !== null && page !== undefined) {
            params.append("page", page);
        }
        
        const headers = ServiceUtil.getAcceptHeader(format);
        return AuthApiService.get(`${url}?${params.toString()}`, headers);
    },

    approve(id) {
        return AuthApiService.patch(`${url}/${id}`, {
            action_state: "APPROVED",
        });
    },

    reject(id) {
        return AuthApiService.patch(`${url}/${id}`, {
            action_state: "REJECTED",
        });
    },
};

export default PendingChangesService;
